"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue_1 = require("vue");
const vue_2 = require("vue");
const _hoisted_1 = ["id"];
const vue_3 = require("vue");
exports.default = (0, vue_1.defineComponent)({
    __name: 'DropdownItem',
    props: {
        to: {
            type: [String, Object],
        },
        pointer: {
            type: Boolean,
            default: false
        },
        id: {
            type: String,
            default: () => { var _a; return `dropdown-item-${(_a = (0, vue_3.getCurrentInstance)()) === null || _a === void 0 ? void 0 : _a.uid}`; }
        }
    },
    emits: ['selected'],
    setup(__props, { emit }) {
        const onSelect = () => {
            emit('selected');
        };
        return (_ctx, _cache) => {
            const _component_router_link = (0, vue_2.resolveComponent)("router-link");
            return (__props.to)
                ? ((0, vue_2.openBlock)(), (0, vue_2.createBlock)(_component_router_link, {
                    key: 0,
                    id: __props.id,
                    to: __props.to,
                    class: (0, vue_2.normalizeClass)(["px-2 py-2 hover:bg-gray", { 'cursor-pointer': __props.pointer }]),
                    onClick: onSelect
                }, {
                    default: (0, vue_2.withCtx)(() => [
                        (0, vue_2.renderSlot)(_ctx.$slots, "default")
                    ]),
                    _: 3
                }, 8, ["id", "to", "class"]))
                : ((0, vue_2.openBlock)(), (0, vue_2.createElementBlock)("div", {
                    key: 1,
                    id: __props.id,
                    class: (0, vue_2.normalizeClass)(["px-2 py-2", { 'cursor-pointer': __props.pointer, 'hover:bg-gray': __props.pointer }]),
                    onClick: onSelect
                }, [
                    (0, vue_2.renderSlot)(_ctx.$slots, "default")
                ], 10, _hoisted_1));
        };
    }
});
